/* Greens & Flowers thema */
(() => {
  'use strict';
  const GF = window.GF || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = !document.documentElement.classList.contains('motion');
  const money = (c) => {
    const v = (c / 100).toFixed(2).replace('.', ',');
    return (GF.moneyFormat || '€{{amount_with_comma_separator}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v).replace(/<[^>]+>/g, '');
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const json = (url, opt) => fetch(url, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, ...opt }).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
  let lenis = null;
  const lockScroll = (on) => { document.body.style.overflow = on ? 'hidden' : ''; if (lenis) on ? lenis.stop() : lenis.start(); };

  /* ---- Menu ---- */
  const rail = $('#rail'), scrim = $('#scrim'), openBtn = $('#menuOpen'), closeBtn = $('#menuClose');
  function setMenu(open) {
    if (!rail) return;
    rail.classList.toggle('is-open', open);
    scrim.hidden = !open;
    openBtn.setAttribute('aria-expanded', String(open));
    lockScroll(open);
    (open ? closeBtn : openBtn).focus({ preventScroll: true });
  }
  openBtn && openBtn.addEventListener('click', () => setMenu(true));
  closeBtn && closeBtn.addEventListener('click', () => setMenu(false));
  scrim && scrim.addEventListener('click', () => setMenu(false));

  /* ---- Winkelwagen ---- */
  const cartEl = $('#cart'), cartScrim = $('#cartScrim'), cartInner = $('#cartInner');
  const setCount = (n, bump) => $$('[data-cart-count]').forEach((el) => {
    el.textContent = n;
    if (bump && el.animate && !reduce) el.animate([{ transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 400, easing: 'ease-out' });
  });
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!cart.item_count) {
      cartInner.innerHTML = `<div class="cart-empty"><p>Je winkelwagen is leeg.</p><a class="btn btn-primary" href="/collections/all">Bekijk de planten</a></div>`;
      return;
    }
    const free = Math.round((GF.freeFrom || 49.99) * 100), left = free - cart.items_subtotal_price;
    cartInner.innerHTML = `<ul class="cart-lines">${cart.items.map((it) => `<li class="cart-line">
      <figure class="cart-thumb tone-sage">${it.image ? `<img src="${esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'))}" alt="">` : ''}</figure>
      <div class="cart-info"><a href="${esc(it.url)}"><strong>${esc(it.product_title)}</strong></a><span>${money(it.final_price)}</span>
        <div class="qty" role="group" aria-label="Aantal"><button type="button" data-qty="${it.key}" data-n="${it.quantity - 1}" aria-label="Minder">−</button><output>${it.quantity}</output><button type="button" data-qty="${it.key}" data-n="${it.quantity + 1}" aria-label="Meer">+</button></div></div>
      <div class="cart-end"><strong>${money(it.final_line_price)}</strong><button type="button" class="cart-rm" data-qty="${it.key}" data-n="0">Verwijderen</button></div></li>`).join('')}</ul>
      <div id="cartRec"></div><div class="cart-ship">${left <= 0 ? '<strong>Gratis verzending</strong> bij deze bestelling.' : `Nog <strong>${money(left)}</strong> tot gratis verzending<span class="ship-bar" style="--v:${Math.round((cart.items_subtotal_price / free) * 100)}"><i></i></span>`}</div>
      <dl class="cart-total"><div><dt>Subtotaal</dt><dd>${money(cart.items_subtotal_price)}</dd></div><div><dt>Verzendkosten</dt><dd>${left <= 0 ? 'Gratis' : 'Bij het afrekenen'}</dd></div><div class="grand"><dt>Totaal</dt><dd>${money(cart.total_price)}</dd></div></dl>
      <a class="btn btn-primary cart-pay" href="/checkout">Afrekenen</a>
      <p class="cart-methods"><span>Veilig betalen met</span> <b>Wero</b> <b>Visa</b> <b>Mastercard</b> <b>American Express</b></p>`;
    cartRec(cart);
  }
  async function cartRec(cart) {
    const box = $('#cartRec'); if (!box || !cart.items.length) return;
    try {
      const pid = cart.items[0].product_id;
      const r = await json(`/recommendations/products.json?product_id=${pid}&limit=4&intent=related`);
      const inCart = new Set(cart.items.map((i) => i.product_id));
      const p = (r.products || []).find((x) => !inCart.has(x.id) && x.available);
      if (!p) return;
      const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      box.innerHTML = `<div class="cart-rec"><h3>Past hier goed bij</h3><a href="${esc(p.url)}">${img ? `<img src="${esc(img)}" alt="" loading="lazy" width="64" height="64">` : '<i></i>'}<strong>${esc(p.title)}</strong><span>${money(Math.round(parseFloat(p.price) * (String(p.price).includes('.') ? 100 : 1)))}</span></a></div>`;
    } catch (e) { /* geen aanbeveling */ }
  }
  const loadCart = () => json(GF.routes.cartJs).then((c) => { renderCart(c); return c; });
  function setCart(open) {
    if (!cartEl) return;
    if (open) loadCart().catch(() => {});
    cartEl.classList.toggle('is-open', open);
    cartEl.setAttribute('aria-hidden', String(!open));
    cartScrim.hidden = !open;
    lockScroll(open);
    if (open) $('#cartClose').focus({ preventScroll: true });
  }
  async function add(variant, btn, qty) {
    const label = btn && btn.textContent;
    if (btn) btn.disabled = true;
    try {
      await json(GF.routes.add + '.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(variant), quantity: Math.max(1, Number(qty) || 1) }] }) });
      const c = await loadCart();
      setCount(c.item_count, true);
      if (btn) { btn.textContent = 'Toegevoegd'; btn.classList.add('is-added'); setTimeout(() => { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 1400); }
      setTimeout(() => setCart(true), 300);
    } catch (e) {
      if (btn) { btn.textContent = 'Niet beschikbaar'; setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1800); }
    }
  }
  
  function galIndex() { const f = $$('.pdp-main [data-slot]').find((x) => !x.hidden); return f ? Number(f.dataset.slot) : 0; }
  function galGo(n) {
    const slots = $$('.pdp-main [data-slot]'); if (!slots.length) return;
    const i = (n + slots.length) % slots.length;
    slots.forEach((f) => (f.hidden = Number(f.dataset.slot) !== i));
    $$('[data-thumb]').forEach((b) => b.setAttribute('aria-selected', String(Number(b.dataset.thumb) === i)));
    const now = $('[data-gal-now]'); if (now) now.textContent = String(i + 1);
  }
  (function pdpExtras() {
    const z = $('[data-zoom]');
    if (z && window.matchMedia('(hover: hover)').matches) {
      z.addEventListener('mousemove', (e) => { const r = z.getBoundingClientRect(); z.style.setProperty('--zx', ((e.clientX - r.left) / r.width) * 100 + '%'); z.style.setProperty('--zy', ((e.clientY - r.top) / r.height) * 100 + '%'); });
    }
    if (z) {
      let x0 = null;
      z.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      z.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 45) galGo(galIndex() + (dx < 0 ? 1 : -1)); }, { passive: true });
    }
    document.addEventListener('keydown', (e) => { if (!z) return; if (e.key === 'ArrowRight' && z.matches(':hover, :focus-within')) galGo(galIndex() + 1); if (e.key === 'ArrowLeft' && z.matches(':hover, :focus-within')) galGo(galIndex() - 1); });
    const c = $('[data-clamp]'); const b = $('[data-clamp-btn]');
    if (c && b && c.scrollHeight > c.clientHeight + 4) b.hidden = false; else if (c) c.classList.remove('is-clamp');
  })();
document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); add(a.dataset.variant, a); return; }
    const o = e.target.closest('[data-cart-open]');
    if (o && cartEl) { e.preventDefault(); setCart(true); return; }
    if (e.target.closest('[data-cart-close]') || e.target === cartScrim) { setCart(false); return; }
    const q = e.target.closest('[data-qty]');
    if (q) json(GF.routes.change + '.js', { method: 'POST', body: JSON.stringify({ id: q.dataset.qty, quantity: Number(q.dataset.n) }) }).then(renderCart);
    const s = e.target.closest('[data-search-open]');
    if (s) { e.preventDefault(); setMenu(false); setSearch(true); }
    if (e.target.closest('[data-search-close]')) setSearch(false);
    const ft = e.target.closest('[data-filt-toggle]');
    if (ft) { const f = $('#filters'); const on = !f.classList.contains('is-open'); f.classList.toggle('is-open', on); ft.setAttribute('aria-expanded', String(on)); }
    const th = e.target.closest('[data-thumb]');
    if (th) galGo(Number(th.dataset.thumb));
    const gs = e.target.closest('[data-gal-step]');
    if (gs) galGo(galIndex() + Number(gs.dataset.galStep));
    const sh = e.target.closest('[data-share]');
    if (sh) {
      const url = location.href.split('#')[0];
      if (navigator.share) { navigator.share({ title: sh.dataset.title, url }).catch(() => {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(() => { sh.setAttribute('aria-label', 'Link gekopieerd'); sh.classList.add('is-done'); setTimeout(() => { sh.classList.remove('is-done'); sh.setAttribute('aria-label', 'Deel deze plant'); }, 2000); }).catch(() => {}); }
    }
    const cb = e.target.closest('[data-clamp-btn]');
    if (cb) { const t = cb.previousElementSibling; const open = t.classList.toggle('is-clamp'); cb.textContent = open ? 'Lees meer' : 'Minder tonen'; }
    const rc = e.target.closest('[data-recover]');
    if (rc) { e.preventDefault(); $('#recover').hidden = false; }
    const ea = e.target.closest('[data-edit-addr]');
    if (ea) { const box = $('#addr-' + ea.dataset.editAddr); box.hidden = !box.hidden; }
    const da = e.target.closest('[data-del-addr]');
    if (da && window.confirm('Dit adres verwijderen?')) { const f = document.createElement('form'); f.method = 'post'; f.action = da.dataset.url; f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (cartEl && cartEl.classList.contains('is-open')) setCart(false);
    if (rail && rail.classList.contains('is-open')) setMenu(false);
    if (searchEl && !searchEl.hidden) setSearch(false);
  });
  document.addEventListener('change', (e) => { if (e.target.matches('[data-sort]')) { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u; } });
  const pf = $('[data-pdp-form]');
  if (pf) pf.addEventListener('submit', (e) => { e.preventDefault(); add(new FormData(pf).get('id'), $('[data-pdp-add]', pf), new FormData(pf).get('quantity')); });
  document.addEventListener('click', (e) => { const st = e.target.closest('[data-qty-step]'); if (!st) return; const qi = $('[data-pdp-qty]'); if (qi) qi.value = Math.min(20, Math.max(1, (Number(qi.value) || 1) + Number(st.dataset.qtyStep))); });
  const sh = $('[data-ship]');
  if (sh) { const p = Number(sh.dataset.price), f = Math.round((GF.freeFrom || 49.99) * 100); sh.innerHTML = p >= f ? '<strong>Gratis verzending</strong> bij deze bestelling.' : `Nog <strong>${money(f - p)}</strong> tot gratis verzending<span class="ship-bar" style="--v:${Math.round((p / f) * 100)}"><i></i></span>`; }

  /* ---- Zoeken ---- */
  const searchEl = $('#search'), input = $('#searchInput'), out = $('#searchOut');
  function setSearch(open) {
    if (!searchEl) return;
    searchEl.hidden = !open;
    lockScroll(open);
    if (open) { input.focus(); input.select(); }
  }
  searchEl && searchEl.addEventListener('click', (e) => { if (e.target === searchEl) setSearch(false); });
  let timer = 0, seq = 0;
  input && input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { out.innerHTML = ''; return; }
    timer = setTimeout(async () => {
      const my = ++seq;
      try {
        const r = await fetch(`${GF.routes.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`).then((x) => x.json());
        if (my !== seq) return;
        const list = r.resources.results.products || [];
        out.innerHTML = list.length
          ? `<p class="s-label">Planten</p>${list.map((p) => `<a class="s-hit" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}<span>${esc(p.title)}<small>${esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '')}</small></span></a>`).join('')}<p class="s-all"><a class="linkish" href="${GF.routes.search}?type=product&q=${encodeURIComponent(q)}">Alle resultaten voor “${esc(q)}”</a></p>`
          : '<p class="s-label">Niets gevonden. Probeer een andere zoekterm.</p>';
      } catch (e) { out.innerHTML = ''; }
    }, 220);
  });

  /* ---- Klantenservice-menu ---- */
  const svc = $('.bn-service');
  if (svc) {
    const tr = $('.bn-trigger', svc);
    tr.addEventListener('click', () => { const o = svc.classList.toggle('is-open'); tr.setAttribute('aria-expanded', String(o)); });
    document.addEventListener('click', (e) => { if (!svc.contains(e.target)) { svc.classList.remove('is-open'); tr.setAttribute('aria-expanded', 'false'); } });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { svc.classList.remove('is-open'); tr.setAttribute('aria-expanded', 'false'); } });
  }

  /* ---- Favorieten ---- */
  const KEY = 'gf-favorites';
  const getFavs = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const setFavs = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) { /* geen opslag */ } };
  const syncFavs = () => { const f = getFavs(); $$('[data-fav-count]').forEach((c) => { c.textContent = f.length; c.hidden = !f.length; }); $$('[data-fav]').forEach((b) => b.setAttribute('aria-pressed', String(f.includes(b.dataset.fav)))); };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    let f = getFavs();
    f = f.includes(b.dataset.fav) ? f.filter((x) => x !== b.dataset.fav) : [...f, b.dataset.fav];
    setFavs(f); syncFavs();
  });
  syncFavs();
  const favGrid = $('#favGrid');
  if (favGrid) {
    const f = getFavs();
    if (f.length) {
      favGrid.innerHTML = '';
      f.forEach(async (h) => {
        try {
          const p = await json(`/products/${h}.js`);
          const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_640x$1$2') : '';
          favGrid.insertAdjacentHTML('beforeend', `<li class="p-item"><div class="p-media"><a class="p-link" href="${esc(p.url)}"><figure class="p-img tone-sage">${img ? `<img class="p-photo" src="${esc(img)}" alt="${esc(p.title)}" loading="lazy">` : ''}</figure></a><button class="p-fav" type="button" data-fav="${esc(h)}" aria-pressed="true" aria-label="Uit favorieten halen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.2 4.2 0 0 1 12 7.8a4.2 4.2 0 0 1 7.5 2.4c0 5.7-7.5 10.3-7.5 10.3Z"/></svg></button></div><a class="p-link p-text" href="${esc(p.url)}"><h3 class="p-name">${esc(p.title)}</h3><p class="p-price">${money(p.price)}</p></a></li>`);
        } catch (e) { /* product bestaat niet meer */ }
      });
    }
  }

  /* ---- Cookiebalk ---- */
  const consent = $('#consent');
  try { if (consent && !localStorage.getItem('gf-consent')) consent.hidden = false; } catch (e) { /* */ }
  document.addEventListener('click', (e) => { if (e.target.closest('[data-consent]')) { try { localStorage.setItem('gf-consent', '1'); } catch (x) { /* */ } consent.hidden = true; } });


  /* ---- Zachte onthulling op alle andere pagina's (geen bibliotheek nodig) ---- */
  (function reveals() {
    if (reduce || !('IntersectionObserver' in window)) return;
    const sel = ['.cat-head', '.crumbs', '.pdp-gallery', '.pdp-info > *', '.page-body', '.page-wrap > h1', '.acc-head', '.acc-tabs', '.acc-panel', '.cart-line', '.cart-total', '.p-item', '.footer-grid > *', '.process-intro', '.trust-list li', '.promises > *', '.ah-head', '.ah-card', '.ah-help'];
    const els = $$(sel.join(',')).filter((el) => !el.closest('.hero') && !el.closest('#rail') && !el.closest('#cart'));
    if (!els.length) return;
    const io = new IntersectionObserver((list) => {
      list.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('rv-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach((el, i) => {
      const r = el.getBoundingClientRect();
      el.classList.add('rv');
      const sib = el.parentElement ? [...el.parentElement.children].indexOf(el) : 0;
      el.style.setProperty('--rv-d', Math.min(sib % 6, 5) * 70 + 'ms');
      io.observe(el);
    });
  })();

  /* ---- Beweging (alleen op de homepage laden) ---- */
  const load = (src) => new Promise((res, rej) => { const s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
  async function motion() {
    const home = $('.hero');
    if (reduce || !home) return;
    try {
      await Promise.all([
        load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js'),
        load('https://cdn.jsdelivr.net/npm/lenis@1.1.13/dist/lenis.min.js'),
      ]);
      await load('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
      gsap.registerPlugin(ScrollTrigger);
      lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
      const small = innerWidth < 1024;
      {
        const t = { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true };
        gsap.to('.hero-art', { yPercent: small ? -3 : -4, ease: 'none', scrollTrigger: t });
        gsap.to('.hero-bg-img', { yPercent: small ? 4 : 6, ease: 'none', scrollTrigger: t });
        gsap.to('.hero-copy', { yPercent: small ? -4 : -9, ease: 'none', scrollTrigger: t });
      }
      ScrollTrigger.batch(['.tile', '.p-img'], { start: 'top 90%', once: true, onEnter: (b) => gsap.to(b, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.1, stagger: 0.09, ease: 'power3.out', onComplete: () => gsap.set(b, { clipPath: 'none' }) }) });
      gsap.to('.steps-line-fill', { scaleY: 1, ease: 'none', scrollTrigger: { trigger: '#steps', start: 'top 70%', end: 'bottom 70%', scrub: true } });
      $$('.step').forEach((s) => ScrollTrigger.create({ trigger: s, start: 'top 70%', onEnter: () => s.classList.add('is-on'), onLeaveBack: () => s.classList.remove('is-on') }));
      document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a || a.getAttribute('href').length < 2) return;
        const t = $(a.getAttribute('href'));
        if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -88, duration: 1.4 }); }
      });
    } catch (err) {
      document.documentElement.classList.remove('motion');
    }
  }
  // De intro draait volledig in CSS; de zware scriptbibliotheken laden pas als de pagina klaar is.
  const startMotion = () => (window.requestIdleCallback ? requestIdleCallback(motion, { timeout: 2500 }) : setTimeout(motion, 600));
  if (document.readyState === 'complete') startMotion(); else addEventListener('load', startMotion, { once: true });
})();
